import { render, staticRenderFns } from "./shipment-document-link.vue?vue&type=template&id=b8049f76&scoped=true"
import script from "./shipment-document-link.vue?vue&type=script&lang=js"
export * from "./shipment-document-link.vue?vue&type=script&lang=js"
import style0 from "./shipment-document-link.vue?vue&type=style&index=0&id=b8049f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8049f76",
  null
  
)

export default component.exports